<template>
  <div class="fill-height pa-4 d-flex flex-column">
    <div
      class="grow d-flex align-center justify-center text-center"
    >
      <div>
        <InstructionsBox
          v-if="instructions"
          :text="instructions"
        />
        <div class="d-flex justify-center">
          <v-checkbox
            v-model="agreed"
            label="Agreed by individual"
            :error-messages="getErrorMessages(v$.agreed)"
            @input="v$.agreed.$touch()"
            @blur="v$.agreed.$touch()"
          />
        </div>
      </div>
    </div>
    <div
      v-if="lastPerformedQuickInterview"
      class="text-center"
    >
      <v-alert
        class="d-inline-block"
        dense
        type="info"
      >
        Last Quick Interview for this Party performed on {{ lastPerformedQuickInterview.startDate | formatDateTime }} and ended in
        {{ lastPerformedQuickInterview.endDate | formatDateTime }} with status {{ lastPerformedQuickInterview.status }}
      </v-alert>
    </div>
  </div>
</template>

<script>
import { helpers } from '@vuelidate/validators'
import { mapGetters } from 'vuex'
import { useVuelidate } from '@vuelidate/core'

import { quickInterviewStatusDetails } from '@/store/quick-interview/state'

import { QUICK_INTERVIEW_NAMESPACE } from '@/store/quick-interview'

import InstructionsBox from '../InstructionsBox.vue'

export default {
  name: 'IntroductionStep',

  components: {
    InstructionsBox,
  },

  props: {
    // eslint-disable-next-line vue/no-unused-properties
    errorList: {
      type: Array,
      default: _ => [],
    },

    instructions: {
      type: String,
      default: '',
    },
  },

  setup () {
    return {
      v$: useVuelidate(),
    }
  },

  data () {
    return {
      agreed: false,
    }
  },

  computed: {
    errors () {
      return this.v$.$errors || []
    },

    lastPerformedQuickInterview () {
      const interview = this.quickInterviewsList.reduce((res, qi) => {
        if (qi.id === this.quickInterview.id) return res
        if (!res) return qi
        if (qi.status_date > res.status_date) return qi
        return res
      }, null)

      if (!interview) return null

      return {
        endDate: interview.status_date,
        startDate: interview.created_at,
        status: quickInterviewStatusDetails[interview.status].description,
      }
    },

    ...mapGetters(QUICK_INTERVIEW_NAMESPACE, [
      'quickInterview',
      'quickInterviewsList',
    ]),
  },

  watch: {
    agreed () {
      this.$emit('changed', true)
    },

    errors: {
      handler: function (value) { this.$emit('update:error-list', value || []) },
      immediate: true,
    },
  },

  validations () {
    return {
      agreed: {
        required: helpers.withMessage('Individual must agree', value => !!value),
      },
    }
  },

  methods: {
    getErrorMessages (validator) { return validator?.$errors.map(e => e.$message) },
  },
}
</script>
